import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {SnackbarService} from "../../../../shared/services/snackbar.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {FormsModule} from "@angular/forms";
import {MatAnchor, MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SlugTransformDirective} from "../../../../shared/directives/slug-transform.directive";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";

@Component({
  selector: 'app-category-detail-admin',
  standalone: true,
  imports: [
    CardsBasicComponent,
    FormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatCheckboxModule,
    SlugTransformDirective,
    TranslateModule,
    LocalizeRouterPipe,
    MatAnchor,
    RouterLinkActive,
    RouterOutlet,
    RouterLink
  ],
  templateUrl: './category-detail-admin.component.html',
  styleUrl: './category-detail-admin.component.css'
})
export class CategoryDetailAdminComponent implements OnInit, OnDestroy{
  categoryId!: number;
  disableSections: boolean = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public _languageService: LanguageService,
    private _route: ActivatedRoute) {
  }

  ngOnInit() {
    this.getRouteParams()
  }

  getRouteParams() {
    this.subscriptions.add(
      this._route.params.subscribe(params => {
        this.categoryId = params['categoryId'];
        this.disableSections = isNaN(Number(this.categoryId));
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}

